import { useState } from 'react';

import { isSubdomain } from '@/helpers/domian';
import socket from '@/services/socket';

export const useSocketShouldUpdateCourses = () => {
  const [updateCount, setUpdateCount] = useState(0);

  socket.on('updateShelve', ({ domain, portal }: { portal: string; domain: string }) => {
    const isPortal = isSubdomain(window.location.host);
    const shouldDispatchEvent =
      (!portal && !isPortal) || (domain && isPortal && new URL(domain).hostname == window.location.hostname);

    if (shouldDispatchEvent) {
      setUpdateCount(count => count + 1);
    }
  });

  return updateCount;
};
